import { useEffect } from 'react';
import { LAZY_CLASS } from './lazyImage';

type Props = {
  title: string;
  src: string;
}
export default function LazyIframe({ title, src }: Props) {
  useEffect(() => {
    window?.lazyLoadInstance?.update();
  }, []);

  return (
    <iframe
      allowFullScreen={true}
      className={LAZY_CLASS}
      data-src={src}
      frameBorder={0}
      title={title}
    />
  );
}

